
import{ PluginCore,IPluginConfig} from "./core/PluginCore"
import { IFeedback, IServerSettings, IFeedbackSetting } from "./Interfaces";
import { ServerSettingsPage } from "./ServerSettingsPage";
/** This class is allows you to configure the features of your plugin.
 * 
 *  You can also implement functions to into the plugin (at start in the constructor, when loading a project, when loading an item)
 * 
     */
export class Plugin extends PluginCore {
   
    
    static csatDOM() {
        return `
        <style>
        .csat_popup {
            position:absolute;
            bottom:60px;
            left:40px;
            background:white;
            width:500px;
            height:330px;
            border: solid 1px #AA9;
            animation: solid;
            box-shadow: #d0d0d0 1px 1px 2px;
            z-index: 1000;
            display:none;
        }
        .csat_body{
            width:100%;
            height:20%;
            text-align:center;
        }
        .csat_header_close{
            padding: 5px;
            float:right;
        }
        .csat_header_title{
            padding-top:15px;
            padding-bottom:15px;
        }
      
       
        .csat_body_ratings{
            padding:0 30px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

        }
        .csat{
            font-size: 30px;
            background: content-box radial-gradient(black, white);
        }
        .nps{
            font-size: 18px;
            border-radius: 100%;
            width: 30px;
            height: 30px;
            text-align: center;
            vertical-align: middle;
            line-height: 30px;
            color:white;
        }
        .csat_footer{
            width:100%;
            height:20%;
            text-align:center;
            position:absolute;
            bottom:0px;
        }
        .rating{
            border-radius: 100%;
            margin: 0 5px;

        }
       
        .csat_footer{
            width:100%;
        }
        .feedback_info{
            width: 50%;
            margin-left: 15%;
            font-size: 11px;
            color: #999;
            line-height: 12px;;
            position:absolute;
            bottom:24px;
        }
        .csat_submit
        {
            position:absolute;
            bottom:20px;
            right:20px;
        }
        .csat.red{
            color: #f95c4a;
            border-color: #f95c4a;
        }
        .csat.orange{
            color: #f87c31;
            border-color: #f87c31;

        }
        .csat.yellow{
            color: #ffbf23;
            border-color: #ffbf23;
        }
        .csat.green{
            color: #89d89c;
            border-color: #89d89c;

        }
        .csat.darkgreen{
            color: #2dad4d;
            border-color: #2dad4d;

        }
        .nps.red{
            background-color: #f95c4a;
        }
        .nps.orange{
            background-color: #f87c31;

        }
        .nps.yellow{
            background-color: #ffbf23;
        }
        .nps.green{
            background-color: #89d89c;

        }
        .nps.darkgreen{
            background-color: #2dad4d;

        }
        .rating:hover{
            cursor:pointer;
            box-shadow: 0 0 0px 3px #888;
        }
        .selected{
            box-shadow: 0 0 0px 3px #555;
        }
        .likely{
            float:right;
            margin-right: 35px;
        }
        .unlikely{
            float:left;
            margin-left: 35px;
        }
        .likely,.unlikely{
            font-size: 11px;
            color: #999;
        }
        .feedback_container{
            
            width:100%;
            padding: 10px 20px;
        }
        .feedbackText{
            margin-top: 10px;
            width: 100%;
        }
                
        </style>
        
        <div class="csat_popup">
        <div class="csat_header_close">
            <div class="csat_header_close_icon fal fa-times-circle"></div>
        </div>
        <div class="csat_body">
            <div class="csat_header_title">
                    <div class="csat_header_title_text">How satisfied are you with Matrix Requirements ?</div>
                </div>
            <div class="csat_body_ratings">
                <span class="csat rating red fa fa-angry" data-value="1"></span> 
                <span class="csat rating orange fa fa-frown" data-value="2"> </span>
                <span class="csat rating yellow fa fa-meh"data-value="3"> </span> 
                <span class="csat rating green fa fa-smile" data-value="4"> </span> 
                <span class="csat rating darkgreen fa fa-grin-stars" data-value="5"> </span> 
            </div>
        
            <div class="csat_header_title">How likely would you recommend our solutions to a friend or a co-worker?</div>
                <div class="csat_body_ratings">
                    <span class="nps rating red"   data-value="0"> 0 </span> 
                    <span class="nps rating red"  data-value="1" > 1 </span> 
                    <span class="nps rating red"  data-value="2"> 2 </span> 
                    <span class="nps rating red"  data-value="3" > 3 </span> 
                    <span class="nps rating red" data-value="4" > 4 </span> 
                    <span class="nps rating red"  data-value="5"> 5 </span> 
                    <span class="nps rating red"  data-value="6"> 6 </span> 
                    <span class="nps rating yellow"  data-value="7"> 7 </span> 
                    <span class="nps rating yellow"  data-value="8"> 8 </span> 
                    <span class="nps rating darkgreen"  data-value="9"> 9 </span> 
                    <span class="nps rating darkgreen"  data-value="10"> 10 </span> 
                </div>
                <div class="likely">
                very likely
                </div>
                <div class="unlikely">
                not likely
                </div>
                <div class="feedback_container">
                    <textarea  rows="3" class="feedbackText" placeholder="What can we do to make your experience more satisfying?"></textarea>
                </div>
        </div>

        <div class="csat_footer">
        <div class="feedback_info">Your feedback is important to us. Please take a moment to rate your experience.</div>
        <button  type="submit" disabled style="float:right" class=" btn btn-success csat_submit" >Send feedback</button>
        </div>
        </div>`;
    }
    
    decidetoRenderCSATPopupAutomatically() {
    
        let settings = ServerSettingsPage().settings();

        let allFeedback: IFeedbackSetting = { feedbacks: [] };
        for (let s of matrixSession.serverConfig.currentUserSettings) {
            if (s.key == Plugin.config.customerSettingsPage.settingName) {
                allFeedback = <IFeedbackSetting>JSON.parse(s.value);
            }
        }   

        let lastFeedbackDate = new Date(0);
        for (let feedback of allFeedback.feedbacks) {
            if( moment(feedback.submitDate) > lastFeedbackDate)
                lastFeedbackDate =  moment(feedback.submitDate);
        }
        let daysSinceLastFeedback = moment().diff(lastFeedbackDate, 'days');
        if (daysSinceLastFeedback > settings.daysBeetweenFeedbacks) {
            // Check localstorage if the user closed the popup.
            let closed = localStorage.getItem("csat_popup_closed_" + matrixSession.getUser());
            if (closed != null)
            {
                let closedDate = new Date(closed);
                let daysSinceClosed = moment().diff(closedDate, 'days');
                if (daysSinceClosed > settings.daysAfterClosedPopup)
                    this.showFeedbackPopupDelayed(settings.timeOutBeforePopup);
            }
            else {
                this.showFeedbackPopupDelayed(settings.timeOutBeforePopup);
            }
        }
    }
    
    
    
    
    renderCSATMenu() {
       
        if (app["waitForMainTree"]) {
            app["waitForMainTree"](() => { this.addFeedBackToHelpMenu(); });
        }
        else {

            let interval = setInterval(() => {
            if( $("#mainHelpBtnMenu").length > 0) {
                if( $("#mainHelpBtnMenu").parents("#navLeft ").length > 0 || window.location.href.indexOf("adminConfig")>0)
                {
                    clearInterval(interval);
                     this.addFeedBackToHelpMenu()
                }
            }

            }, 1000);
            setTimeout(() => {  } , 2000);
        }


       
    }
    addFeedBackToHelpMenu() { 
            
            let li = $("<li><a>Share your feedback</a></li>");
            $("#mainHelpBtnMenu").append(li);
            li.on("click", () => {
                    this.showFeedbackPopup();
            });
            if(!matrixSession.isSuperAdmin())
                this.decidetoRenderCSATPopupAutomatically();
    }

    showFeedbackPopupDelayed(timeOutBeforePopup: number) {
        setTimeout(() => {
            this.showFeedbackPopup();
        }, timeOutBeforePopup);
    }

    showFeedbackPopup() {
   
        $(".csat_popup").remove();
        let buttonEnabled = false;
        let csat = document.createElement('div');
        csat.innerHTML = Plugin.csatDOM();
        document.body.appendChild(csat);
        $(".csat_popup").fadeIn();
        $(".csat_header_close_icon").on("click", () => {
            // Let save the date that the user closed the popup.
            localStorage.setItem("csat_popup_closed_" + matrixSession.getUser(), new Date().toISOString());
            $(".csat_popup").fadeOut();
        });
        $(".rating", csat).on("click", (evt) => {
            $('.csat_submit').removeAttr("disabled");
            if ($(evt.target).hasClass("csat")) {
                $(".csat").removeClass("selected");
                $(evt.target).addClass("selected");
            }
            else {
                $(".nps").removeClass("selected");
                $(evt.target).addClass("selected");
            }
        });
        $(".feedbackText").on("keyup", () => {

            if ((<string>$(".feedbackText").val()).length > 0) {
                $('.csat_submit').removeAttr("disabled");
            }
            else {
                if(  $(".rating.selected ").length == 0 )
                    $('.csat_submit').attr("disabled", "true");
            }


         });
    
        $('.csat_submit').on("click", async () => { 
    
            let csat = $(".csat.selected").data("value");
            let nps = $(".nps.selected").data("value");
            let feedback = <string> $(".feedbackText").val();
            $(".csat_popup").fadeOut();

            let data:IFeedback = {
                "csat": csat,
                "nps": nps,
                "feedback": feedback,
                "user": matrixSession.getUser(),
                "submitDate": new Date().toISOString()
            }
            let settingId = Plugin.config.customerSettingsPage.settingName;
            console.log(data);
            let settings:XRUserType =  <XRUserType> await restConnection.getServer("user/" + matrixSession.getUser()) ;
            
            let npsCSATValue:IFeedbackSetting = {feedbacks:[] };
            for (let setting of settings.userSettingsList) {
                if (setting.key == settingId) {
                    npsCSATValue = JSON.parse(setting.value);
                    break;
                }
            }
            npsCSATValue.feedbacks = npsCSATValue.feedbacks.filter(o => o.user == matrixSession.getUser());
            npsCSATValue.feedbacks.push(data);

            await restConnection.postServer( "user/"+matrixSession.getUser()+ "/setting", {
                key:settingId,
                value:JSON.stringify(npsCSATValue),
                reason: "Respond to CSAT"
            })

            ml.UI.showSuccess("Thank you for your feedback!");
            //Save customer settings
    
          
        });
    }
    






    /**This part enables which 
     * 
     * See IPluginConfig interface for explanation of parameters
    */
    
    static config: IPluginConfig = {
        /*  Page in admin client to configure settings across all projects - set enabled to false if not needed. 
            The page itself is implemented in the _ServerSettingsPage.ts 
        */
        customerSettingsPage: {
            id: "NPS_CSATCustomerSettings",
            title: "NPS and CSAT",
            type: "NPS_CSATcs",
            enabled: true,
            defaultSettings: {
                daysBeetweenFeedbacks: 180,
                daysAfterClosedPopup: 7,
                timeOutBeforePopup:20000,
            },
            settingName: "NPS_CSAT_settings",
            help: "This page displays NPS and CSAT and  feedback from our customers. We appreciate your feedback and use it to improve our products and services.",
            helpUrl:"https://docs23.matrixreq.com"
        },
        /*  Page in admin client to configure settings for one specific project - set enabled to false if not needed.
            The page itself is implemented in the _ProjectSetingsPage.ts 
        */
        projectSettingsPage: {
            id: "NPS_CSATprojectsettings",
            title: "NPS_CSAT projectsettings page",
            type:"NPS_CSATps",
            enabled: false,
            defaultSettings: {
                myProjectSetting:  "default value for setting defined in Interfaces.ts",
            },
            settingName: "NPS_CSAT_settings",
            help: "",
            helpUrl:"https://docs23.matrixreq.com"
        },
        /*  Add an entry in the tool menu of an item or folder - set enabled to false if not needed.
            The tool itself is implemented in the _Tool.ts 
        */
        menuToolItem: {
            enabled: false,
            title:"ui_plugin_csat_nps-menuitem",
        },
        /*  Add a custom field to enter some data in the UI - set enabled to false if not needed.
            The field itself is implemented in the _Control.ts 
        */
        field: {
            enabled: false,
            fieldType: "ui_plugin_csat_nps",
            title: "ui_plugin_csat_nps-field",
            fieldConfigOptions: {
                id: "ui_plugin_csat_nps",
                capabilities: {
                    canBePublished: false,
                    canBeReadonly: true,
                    canBeXtcPreset: false,
                    canHideInDoc: false,
                    canBeUsedInDocs: false,
                    canRequireContent: true,
                },
                class: "",
                help: "",
                label: "ui_plugin_csat_nps-field",
            }
        },
        /*  Add a dashboard inside a project - set enabled to false if not needed.
            The field itself is implemented in the _Control.ts 
        */
        dashboard: {        
            
            id:"NPS_CSAT",
            title: "NPS_CSAT dashboard page",
            enabled: false,
            icon: "fal fa-cog",
            parent: "DASHBOARDS",
            usefilter: true,
            order: 9999,
        }
    };

    /**
     * The constructor is loaded once after all the source code is loaded by the browser. 
     * Nothing is known about the instance, project, user etc.
     * You can use it to initialize things like callbacks after item changes
     */
    constructor() {
        super();
        
        // here is a good place to register callbacks for UI events (like displaying or saving items)
    }

    /**
     * This method is called each time  a project has been loaded and initialized. 
     * At the time it is called, all project settings, categories etc are defined.
     * 
     * @param project // id of the loaded project
     */
    onInitProject(project:string) {

        // here is a good place to decide based on the project (maybe some project setting), whether the plugin should be enabled 
        
        // if not:
        // this.enabledInContext = false;
    }

    /** this method is called just before the rendering of an item is done
    * It is also called when opening the create item dialog.
    * 
    * @param _item: the item which is being loaded in the UI 
    */
    onInitItem(item: IItem) {
        
        // here is a good place to decide based on the selection in the tree, whether the plugin should be enabled 
        
        // if not:
        // this.enabledInContext = false;
    }
}

declare global {
    
    // eslint-disable-next-line no-unused-vars
    interface Window {
        plugins: unknown;
    }
}
    $(() => {
    // Register the plugin
        $(function () {
            let p = new Plugin()
            window.plugins.register(p);
            p.renderCSATMenu();
        });
    
});

